/**
 * [一般開発者利用不可]
 * ログレベル
 */
export enum LogLevel {
  ERROR = 4,
  WARN  = 3,
  INFO  = 2,
  DEBUG = 1
}
